import Content from "./content";
import './../../pages/home/components/homePage.css';

const Main = () => {
	return (
		<Content/>
	)
}
export default Main